(function () {
  // 和你现有 Klaviyo 逻辑里一致的「从 href 取 id」实现，若你已有全局函数可复用
  function getIdFromUrl(href) {
    if (!href || typeof href !== 'string') return null;
    try {
      var url = new URL(href, window.location.origin);
      var match =
        url.searchParams.get('id') ||
        url.pathname.match(/\/([a-zA-Z0-9]+)$/) ||
        url.hash.slice(1);
      return (match && (typeof match === 'string' ? match : match[1])) || null;
    } catch (e) {
      return null;
    }
  }

  function isKlaviyoPopupLink(anchor) {
    var title = (anchor.getAttribute('title') || '').toLowerCase();
    var href = anchor.getAttribute('href');
    var id = getIdFromUrl(href);
    return title === 'klaviyo' && !!id;
  }

  function isExternalLink(anchor) {
    var href = (anchor.getAttribute('href') || '').trim();
    if (
      !href ||
      href === '#' ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return false;
    }
    try {
      var url = new URL(href, window.location.origin);
      return url.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!(e.target instanceof Element)) return;
      var a = e.target.closest('a');
      if (!a || !a.href) return;

      if (isKlaviyoPopupLink(a)) {
        // Prevent navigation only; other handlers still run (timeline-card skips defaultPrevented clicks).
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', getIdFromUrl(a.getAttribute('href'))]);
        return;
      }

      if (a.hasAttribute('data-no-external-new-tab')) return;

      // 已配置 target="_blank" 时交给浏览器原生跳转，避免移动端拦截 window.open
      if (a.getAttribute('target') === '_blank') return;

      if (isExternalLink(a)) {
        e.preventDefault();
        window.open(a.href, '_blank', 'noopener,noreferrer');
      }
    },
    true,
  );
})();
